<div *ngIf="loading" class="loading-backdrop"></div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.4)"
  size="medium"
  color="#000"
  type="ball-spin"
  [showSpinner]="loading"
  [fullScreen]="true">
</ngx-spinner>

<div *ngIf="environment && environment !== 'Production'" class="environment-banner">
  {{ environment }}
</div>
<router-outlet></router-outlet>